import { isRealOnline, isStageFsim } from '@common/utils/env';

export default {
  install(vue, options: object) {
    // 初始化
    window.ubs_da = window.UBSDataAnalytic;
    // 是否老版本原生sdk容器场景
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    if ((window.ZKJ_iOS_JS_Bridge || window.ZKJ_APP_New_H5_Bridge) && window.ZKJDataAnalytic) {
      window.ubs_da = window.ZKJDataAnalytic;
    }
    const isFsim = isStageFsim();
    const isOnline = isRealOnline();
    // 区分测试与生产上报环境
    let server_url = '';
    if (isOnline) {
      server_url = 'https://ubs.xiaolongcloud.com/ubs?project=default';
    } else if (isFsim) {
      server_url = 'https://ubs-fsim.xiaolongcloud.local/sa?project=default';
    } else {
      server_url = 'http://ubstest.msxf.test:8106/sa?project=999';
    }

    // 这个是双报，约定某个事件报另外个地址
    // const quickly_linker_url = isOnline
    //   ? 'https://ubs.msxf.com/receive/data?project=default'
    //   : 'https://ubs-test.msxf.com/receive/data?project=default';
    // window.ubs_da?.use('QuicklyLinker', {
    //   server_url: quickly_linker_url,
    //   dataFilter: function (event_name, data) {
    //     if (data?.properties?.realTimeReport) {
    //       return true;
    //     }
    //     return false;
    //   },
    // });
    window.ubs_da?.init({
      app_js_bridge: true,
      send_type: 'beacon',
      server_url,
      show_log: process.env.NODE_ENV !== 'production',
      preset_properties: {
        title: true,
        url: true,
      },
    });

    // 拦截处理spm5层只有p_id的数据
    window.ubs_da?.registerPropertyPlugin?.({
      isMatchedWithFilter(data: any) {
        // 如果只有p_id，没有其他id
        const { p_id, m_id, t_id, s_id, e_id } = data?.properties ?? {};
        return p_id && !(m_id || t_id || s_id || e_id);
      },
      properties(data: any) {
        // 删除p_id
        delete data.properties.p_id;
      },
    });

    // 开启页面时长统计
    window.ubs_da?.use('PageSessionId');
    // 设置或监控 SPM相关信息变动
    process.env.APP_NAME === 'repay' && window.ubs_da?.use('SpmReferrer');
  },
};
